import { MILLISECONDS } from '../utils/date';
import { sortBy } from 'lodash';
export const pollRules = sortBy([
    {
        timeToStart: MILLISECONDS.ONE_HOUR,
        step: MILLISECONDS.ONE_MINUTE,
    },
    {
        timeToStart: MILLISECONDS.ONE_MINUTE * 5,
        step: MILLISECONDS.ONE_MINUTE / 6,
    },
    {
        timeToStart: -MILLISECONDS.ONE_MINUTE * 5,
        step: MILLISECONDS.ONE_MINUTE / 6,
    },
    {
        timeToStart: -MILLISECONDS.ONE_HOUR,
        step: MILLISECONDS.ONE_MINUTE / 2,
    },
], 'timeToStart');
export const pendingLivePollRule = { step: MILLISECONDS.ONE_MINUTE / 20 };
//# sourceMappingURL=live-poll-rules.js.map